export const API_URL = "https://api.otokata.id/api/";
// export const API_URL = "http://localhost:8000/api/";
export const API_URL_CORE = "https://chat.otokata.id:8070/";
// export const API_URL_CORE = "http://localhost:8091/";
export const API_URL_PAYMENT = "https://chat.otokata.id:8090/";
export const WS_URL = "wss://chat.otokata.id:8090/";
export const BASE_URL = "https://chat.otokata.id/";
// export const API_URL = "http://localhost:8000/";
// export const BASE_URL = "http://localhost:3000/";
